module.exports = __webpack_public_path__ + "img/Closed Icon - charcoal.56c8919a.svg";